var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import { Group, Path } from "paper";
import { staticImplements } from "types";
let IsoCuboid = class IsoCuboid {
    render(appearance) {
        const { width, height, depth } = appearance;
        // Origin is in the center.
        // We need to define seven corners
        /*
                      a
                b           c
                      d


                e           f
                      g

            height: b -> e
            depth: g -> f
            width: e -> g

            atan(1/2) = 26.5650512
        */
        const vHeight = P(0, height);
        const vDepth = P(depth, 0).rotate(-26.5650512);
        const vWidth = P(width, 0).rotate(26.5650512);
        const o = P(0, 0);
        const f = o.add(vHeight).add(vDepth).add(vWidth).divide(2);
        const c = f.subtract(vHeight);
        const a = c.subtract(vWidth);
        const b = a.subtract(vDepth);
        const e = b.add(vHeight);
        const g = e.add(vWidth);
        const d = g.subtract(vHeight);
        // Move the points slightly to cover gaps between the walls.
        const topWall = new Path([a, c.add([0, 1]), d.add([0, 1]), b.add([0, 1])]).close();
        const rightWall = new Path([d.subtract(vDepth.normalize()), c, f, g]).close();
        const leftWall = new Path([b, d, g, e]).close();
        const graphic = new Group([topWall, rightWall, leftWall]);
        BasicShapes.applyCustom(appearance, (fill) => {
            topWall.fillColor = fill;
            leftWall.fillColor = fill.color().ladd(5).string();
            rightWall.fillColor = fill.color().ladd(-5).string();
        }, (width, stroke) => {
            const outline = new Path([a, c, f, g, e, b])
                .close()
                .withStroke(width, stroke);
            graphic.addChild(outline);
        });
        return {
            graphic,
            hitShape: graphic.rectHitShape()
        };
    }
};
IsoCuboid.properties = {
    label: "Isometric Cuboid",
    defaultAppearance: Object.assign(Object.assign({}, BasicShapes.defaultAppearance), { width: 100, height: 120, depth: 100 }),
    appearanceSpecs: [
        ...BasicShapes.specs,
        BasicShapes.header,
        {
            spec: "slider", key: "width", label: "Width",
            min: 10, max: 500,
        },
        {
            spec: "slider", key: "height", label: "Height",
            min: 10, max: 500,
        },
        {
            spec: "slider", key: "depth", label: "Depth",
            min: 10, max: 500,
        },
    ],
};
IsoCuboid = __decorate([
    staticImplements()
], IsoCuboid);
export { IsoCuboid };
